import Decimal from "./Decimal";

function JustFloat(value, integerPartLength = 99, fractionalPartLength = 2) {
	const regExp = new RegExp('[0-9]{0,'+integerPartLength+'}'+(fractionalPartLength ? '[\,\.]?' : '') + '[0-9]{0,'+fractionalPartLength+'}');
	const val = value.match(regExp)[0].replace(",", ".");
	if (!val) {
		return "";
	} else if (val.substr(-1) === ".") {
		return val.replace(".", ",");
	} else {
		return Number.parseFloat(val).toString().replace(".", ",");
	}
}

function Str2Number(element){
	const [integerPartLength, fractionalPartLength] = (element.dataset.number + ",0").split(',').map(n => parseInt(n) || 0);
	const maxLength = (integerPartLength || 0) + (fractionalPartLength || 0) + (fractionalPartLength ? 1 : 0);

	const OnChange = e => {
		const newValue = JustFloat(e.currentTarget.value, integerPartLength, fractionalPartLength) || "";
		if(newValue > maxLength){
			element.value = newValue.substr(0, maxLength);
		}
		else{
			element.value = newValue;
		}	
	}

	element.addEventListener('input', OnChange);
}

function InputNumberFixer(){
	const numberElements = document.querySelectorAll('[data-number]');
	[...numberElements].forEach(Str2Number);	
}

export default InputNumberFixer;